import {
  get_fastSeconds3ld6xqdi008l3 as get_fastSeconds,
  _FastDuration___get_seconds__impl__4kvvavkn2srn5t4e0w as _FastDuration___get_seconds__impl__4kvvav,
  get_CoreTime23yr4od90u6o9 as get_CoreTime,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  _FastDuration___get_microseconds__impl__o4j93h2rn63lkq7a8kl as _FastDuration___get_microseconds__impl__o4j93h,
  get_slowaqovrrnrezzv as get_slow,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  Companion_instance3gshkh79a96f7 as Companion_instance,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  DurationUnit_NANOSECONDS_getInstance2sujg77gnqrxb as DurationUnit_NANOSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  equals2au1ep9vhcato as equals,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class PerformanceCounter {
  constructor() {
    PerformanceCounter_instance = this;
    this.w7s_1 = nowMillis(this);
  }
  x7s() {
    return _FastDuration___get_nanoseconds__impl__pxizcb(ellapsed(this));
  }
  y7s() {
    return _FastDuration___get_microseconds__impl__o4j93h(ellapsed(this));
  }
  z7s() {
    return get_slow(ellapsed(this));
  }
  a7t() {
    return ellapsed(this);
  }
}
class Stopwatch {
  constructor(nanosecondProvider) {
    var tmp;
    if (nanosecondProvider === VOID) {
      tmp = Stopwatch$_init_$lambda_lg3mf2;
    } else {
      tmp = nanosecondProvider;
    }
    nanosecondProvider = tmp;
    this.b7t_1 = nanosecondProvider;
    this.c7t_1 = false;
    this.d7t_1 = 0.0;
  }
  v2f() {
    setStart(this);
    this.c7t_1 = true;
    return this;
  }
  e7t() {
    return this.c7t_1 ? _get_currentNano__jndyu4(this) - this.d7t_1 : this.d7t_1;
  }
  f7t() {
    // Inline function 'korlibs.time.nanoseconds' call
    var this_0 = this.e7t();
    return toDuration(this_0, DurationUnit_NANOSECONDS_getInstance());
  }
  g7t() {
    return get_fastNanoseconds(this.e7t());
  }
}
class IntTimedCache {
  constructor(ttl, timeProvider, gen) {
    timeProvider = timeProvider === VOID ? Companion_instance : timeProvider;
    this.h7t_1 = ttl;
    this.i7t_1 = timeProvider;
    this.j7t_1 = gen;
    this.k7t_1 = Companion_getInstance().i35_1;
    this.l7t_1 = 0;
  }
  np(obj, property) {
    // Inline function 'korlibs.time.IntTimedCache.get' call
    var now = this.i7t_1.m35();
    if (equals(this.k7t_1, Companion_getInstance().i35_1) || Duration__compareTo_impl_pchp0f(DateTime__minus_impl_10njw8(now, this.k7t_1), this.h7t_1) >= 0) {
      this.k7t_1 = now;
      this.l7t_1 = this.j7t_1();
    }
    return this.l7t_1;
  }
}
//endregion
function _Frequency___init__impl__upasnx(hertz) {
  return hertz;
}
function _Frequency___get_hertz__impl__9m7k6x($this) {
  return $this;
}
function _Frequency___get_fastDuration__impl__87web0($this) {
  return get_fastSeconds(1.0 / _Frequency___get_hertz__impl__9m7k6x($this));
}
function get_hz(_this__u8e3s4) {
  return get_timesPerSecond(_this__u8e3s4);
}
function toFrequency(_this__u8e3s4) {
  return get_timesPerSecond_0(_this__u8e3s4);
}
function get_timesPerSecond(_this__u8e3s4) {
  return _Frequency___init__impl__upasnx(_this__u8e3s4);
}
function get_timesPerSecond_0(_this__u8e3s4) {
  return _Frequency___init__impl__upasnx(1.0 / _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4));
}
var KlockLocale_default;
function nowMillis($this) {
  return get_CoreTime().w35();
}
function ellapsed($this) {
  return get_fastMilliseconds(nowMillis($this) - $this.w7s_1);
}
var PerformanceCounter_instance;
function PerformanceCounter_getInstance() {
  if (PerformanceCounter_instance === VOID)
    new PerformanceCounter();
  return PerformanceCounter_instance;
}
function _get_currentNano__jndyu4($this) {
  return $this.b7t_1();
}
function setStart($this) {
  $this.d7t_1 = _get_currentNano__jndyu4($this);
}
function Stopwatch$_init_$lambda_lg3mf2() {
  return PerformanceCounter_getInstance().x7s();
}
var ExtendedTimezoneNamesOrNull;
//region block: post-declaration
initMetadataForObject(PerformanceCounter, 'PerformanceCounter');
initMetadataForClass(Stopwatch, 'Stopwatch', Stopwatch);
initMetadataForClass(IntTimedCache, 'IntTimedCache');
//endregion
//region block: init
KlockLocale_default = null;
ExtendedTimezoneNamesOrNull = null;
//endregion
//region block: exports
export {
  _Frequency___get_fastDuration__impl__87web0 as _Frequency___get_fastDuration__impl__87web01nqjqeilxp91g,
  _Frequency___get_hertz__impl__9m7k6x as _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1,
  PerformanceCounter_getInstance as PerformanceCounter_getInstance3b8d94s1bsc37,
  IntTimedCache as IntTimedCache39ymx9abjz88x,
  Stopwatch as Stopwatch1guqi4xl0rpfb,
  get_hz as get_hz3a5o5age7b808,
  toFrequency as toFrequency3flbtmp5xney7,
};
//endregion
